export default __webpack_public_path__ + "static/media/Light.5d604258.svg";